import(/* webpackMode: "eager", webpackExports: ["Canonical"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/Canonical.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/styles/_index.scss");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
